var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg:text-lg xl:text-xl",class:{ 'lg:w-11/12': !_vm.fullWidth }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }